import styled from 'styled-components';

import { rgba } from 'polished';

import colors from '../../../constants/colors';

import icCloseBlack from '../../../assets/icons/ic_close_black.svg';

import DefaultVideoPlayer from '../../DefaultVideoPlayer';
import { Background } from '../styles';

export const BackgroundStyled = styled(Background)``;

export const Arrows = styled.button`
  background: ${rgba(colors.main.black, 0.4)} !important;
  border-radius: 2px;
  transition: all 0.3s;
  top: 50%;
  right: -20px;
  transform: translate(-100%, -50%);
  left: initial;
  height: 61px;
  width: 61px;
  z-index: 100;

  &:after {
    display: none;
  }

  &:before {
    position: absolute;
    top: 50%;
    left: 50%;
    content: '';
    opacity: 1;
    border: solid ${colors.main.white};
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 4px;
    transform: translate(-50%, -50%) rotate(135deg);
  }

  &.slick-prev {
    right: initial;
    left: -20px;
  }

  &.slick-next {
    transform: translate(100%, -50%) rotate(180deg);
  }
`;

export const Content = styled.div`
  background-color: ${colors.main.white};
  width: 640px;
  min-height: 480px;
  padding: 48px 48px 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 16px;
  box-shadow: 0 30px 80px ${rgba(colors.main.black, 0.2)};
  opacity: 0.99;
  animation: fadein 0.6s;
  animation-fill-mode: backwards;
  z-index: 10002;

  .slick-slider {
    position: static;
    width: 100%;
  }

  @media screen and (max-width: 768px) {
    width: calc(100% - 24px);
    padding: 32px 24px 40px;
  }

  @keyframes fadein {
    0% {
      opacity: 0;
    }
    20% {
      opacity: 0.2;
    }
    40% {
      opacity: 0.4;
    }
    60% {
      opacity: 0.6;
    }
    80% {
      opacity: 0.8;
    }
    85% {
      opacity: 0.8;
    }
    90% {
      opacity: 0.9;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes easein {
    from {
      transform: translate(-50%, 140%);
    }
    to {
      transform: translate(-50%, -50%);
    }
  }
`;

export const CloseIcon = styled.div`
  width: 25px;
  height: 25px;
  background: url(${icCloseBlack});
  position: absolute;
  top: 0;
  right: 0;
  margin: 15px 15px 0 0;
  cursor: pointer;
`;

export const Title = styled.div`
  position: relative;
  width: 100%;
`;

export const SubTitle = styled.div`
  position: absolute;
  left: 50%;
  bottom: -6px;
  transform: translateX(-50%);
  width: 100%;
`;

export const ReachedDateTitle = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 520px;

  @media screen and (max-width: 992px) {
    width: 89.9%;
  }
`;

export const ReachedDateValue = styled.div`
  margin: 12px auto 0;
  width: 100%;
  max-width: 520px;
`;

export const Achievement = styled.div`
  outline: none;
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const AchievementBadge = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 150px;
  height: 150px;
  position: relative;
  pointer-events: none;

  svg {
    font-size: 140px;
  }

  .achievement-icon-inline,
  .achievement-icon-inline svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  @media screen and (max-width: 765px) {
    width: 120px;
    height: 120px;

    svg {
      font-size: 120px;
    }

    .achievement-icon-inline,
    .achievement-icon-inline svg {
      width: 100%;
      height: 100%;
    }
  }
`;

export const BadgePlaceholder = styled.div`
  width: 130px;
  height: 130px;
  border-radius: 20px;
  border: 2px dashed ${rgba(colors.main.black, 0.2)};
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.08em;
  color: ${rgba(colors.main.black, 0.5)};
  padding: 12px;
  text-align: center;
  pointer-events: none;
  z-index: 1;
`;

export const MediaStage = styled.div`
  width: 100%;
  margin: 48px auto 24px;
  display: flex;
  justify-content: center;
`;

export const VideoWrapper = styled.div`
  width: min(560px, 100%);
  aspect-ratio: 16 / 9;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 40px ${rgba(colors.main.black, 0.15)};
  background: ${rgba(colors.main.black, 0.04)};
  display: flex;
`;

export const SlideVideoPlayer = styled(DefaultVideoPlayer)`
  width: 100%;
  height: 100%;
  --media-object-fit: cover;
  --media-object-position: center;

  .default-video-player__mux,
  mux-player {
    width: 100% !important;
    height: 100% !important;
  }

  .default-video-placeholder {
    height: 100%;
    min-height: 0;
    max-width: none;
    border-radius: 0;
  }
`;
